/*
 * @Author: Latte
 * @Date: 2021-05-27 16:34:31
 * @LAstEditors: Latte
 * @LastEditTime: 2021-10-27 11:24:43
 * @FilePath: \Siui.Cloud.Medical.Web\src\api\expertManagement.js
 */
import request from '@/utils/request'
import config from '@/utils/config'

/**
 *  获取专家列表
 *
 * @param {*} params
 */
export function getAllExpertList(params) {
	return request({
		url: config.API_ADMIN + '/Api/V1/AdminUltraExpert/List',
		method: 'get',
		params
	})
}

/**
 *  添加专家
 *
 * @param {*} data
 */
export function addExpert(data) {
	return request({
		url: config.API_ADMIN + '/Api/V1/AdminUltraExpert/Add',
		method: 'post',
		data
	})
}

/**
 *  删除专家
 *
 * @param {*} params
 */
export function deleteExpertOrBack(params) {
	return request({
		url: config.API_ADMIN + '/Api/V1/AdminUltraExpert/DeleteOrBack',
		method: 'delete',
		params
	})
}

/**
 *  获取专家信息
 *
 * @param {*} params
 */
export function getExpertInfo(params) {
	return request({
		url: config.API_ADMIN + '/Api/V1/AdminUltraExpert/Search',
		method: 'get',
		params
	})
}

/**
 * 后台专家信息更新
 * @param {Object} data
 */
export function updateExpertInfo(data) {
	return request({
		url: config.API_ADMIN + '/Api/V1/AdminUltraExpert/Update',
		method: 'post',
		data
	})
}

/**
 *  更新专家等级
 *
 * @param {*} params
 */
// export function setExpertLevel(params) {
//   return request({
//     url: config.API_ADMIN + '/Api/V1/AdminUltraExpert/Update',
//     method: 'post',
//     params
//   })
// }

/**
 *  后台关系设置通过审核或者取消通过审核
 *
 * @param {*} params
 */
// export function setExpertStatus(params) {
//   return request({
//     url: config.API_ADMIN + '/Api/V1/AdminUltraExperts/PassOrCancel',
//     method: 'post',
//     params
//   })
// }
